import styled from 'styled-components';
import { gridSize } from 'common/pocket-casts-styles';

export const StyledSpacer = styled.div`
    width: ${props => props.n * gridSize}px;
    height: ${props => props.n * gridSize}px;
`;
